/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FieldOption {
  Optional = 'Optional',
  Required = 'Required',
  ReadOnly = 'ReadOnly'
}
